import { InputField } from 'components-new'
import { availableCountriesAndCurrencies } from 'components-new/inputs/CurrencyAutocomplete/CurrencyAutocomplete.model'
import { useCountryPolicy } from 'pages/advanced-credit-policy/CountryPolicyProvider'
import React from 'react'

const DebtInput = ({ isAdvanced = true }) => {
  const { policy, setPolicy, isInferiorPlan, selectedCountry } = useCountryPolicy()
  const defVal = policy.debt ?? 0
  const [val, setVal] = React.useState<number>(defVal)
  const currency = availableCountriesAndCurrencies?.filter(
    (countryCurr) => countryCurr.country === selectedCountry?.toUpperCase()
  )[0]

  // this is needed to set the initial value after it's been null
  React.useEffect(() => {
    if (typeof policy.debt === 'number') {
      setVal(policy.debt)
    }
  }, [policy.debt])

  return (
    <InputField
      value={val}
      addOn={currency?.currency}
      handleChange={function (value: string): void {
        if (isNaN(Number(value))) return
        setVal(Number(value))
        setPolicy({ ...policy, debt: Number(value) })
      }}
      disabled={isAdvanced && isInferiorPlan}
    />
  )
}

export default DebtInput
